// extracted by mini-css-extract-plugin
export var communityStat = "styles-module__communityStat___rFjl7";
export var container = "styles-module__container___OpWus";